export enum MeasureCategory {
  HEDIS_NLP = "HedisNLP",
  HEDIS_MANUAL_CHASE_CREATION = "HedisManualChaseCreation",
}
